import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export function SupplierCreateDialog({ invoice, open, onClose, onCreated }) {
  const [form, setForm] = useState({ name: "", tax_id: "" });

  useEffect(() => {
    if (open && invoice) {
      setForm({ name: invoice.supplier_name_raw || "", tax_id: invoice.supplier_tax_id || "" });
    }
  }, [open, invoice]);

  const create = async () => {
    if (!form.name.trim()) { toast.error("El nombre es obligatorio"); return; }
    try {
      const r = await api.post("/suppliers", { name: form.name.trim(), tax_id: form.tax_id.trim() || null });
      await api.patch(`/invoices/${invoice.id}`, { supplier_id: r.data.id });
      toast.success(`Proveedor "${r.data.name}" creado y asignado`);
      onClose();
      onCreated(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || "Error al crear proveedor"); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="supplier-create-dialog">
        <DialogHeader><DialogTitle className="font-heading">Nuevo proveedor</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1"><Label className="text-xs">Nombre</Label>
            <Input data-testid="supplier-create-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
          <div className="space-y-1"><Label className="text-xs">CIF/NIF (opcional)</Label>
            <Input data-testid="supplier-create-tax-id" value={form.tax_id} onChange={(e) => setForm({ ...form, tax_id: e.target.value })} /></div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" data-testid="supplier-create-cancel" onClick={onClose}>Cancelar</Button>
            <Button data-testid="supplier-create-save" onClick={create} className="bg-[#D9381E] hover:bg-[#B91C1C] text-white">Crear y asignar</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
